import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  surveyData: {},
  currentFormId: null,
  formResponses: {},
};

export const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    // Save survey data for a specific form
    setSurveyData: (state, action) => {
      state.surveyData = {
        ...state.surveyData,
        ...action.payload,
      };
    },
    
    // Set the current form being worked on
    setCurrentFormId: (state, action) => {
      state.currentFormId = action.payload;
    },
    
    // Save form responses for a specific form ID
    saveFormResponse: (state, action) => {
      const { formId, responses } = action.payload;
      state.formResponses = {
        ...state.formResponses,
        [formId]: responses,
      };
    },
    
    // Update a specific response within a form
    updateFormResponse: (state, action) => {
      const { formId, fieldKey, value } = action.payload;
      
      if (!state.formResponses[formId]) {
        state.formResponses[formId] = {};
      }
      
      state.formResponses[formId] = {
        ...state.formResponses[formId],
        [fieldKey]: value,
      };
    },
    
    // Clear responses for a specific form
    clearFormResponse: (state, action) => {
      const formId = action.payload;
      if (state.formResponses[formId]) {
        delete state.formResponses[formId];
      }
    },
    
    // Clear all survey data
    clearAllSurveyData: (state) => {
      state.surveyData = {};
      state.currentFormId = null;
      state.formResponses = {};
    },
  },
});

// Export actions
export const {
  setSurveyData,
  setCurrentFormId,
  saveFormResponse,
  updateFormResponse,
  clearFormResponse,
  clearAllSurveyData,
} = surveySlice.actions;

// Export selectors
export const selectSurveyData = (state) => state.survey.surveyData;
// Stable empty object reference to prevent re-renders
const EMPTY_FORM_RESPONSE = {};

export const selectCurrentFormId = (state) => state.survey.currentFormId;
export const selectFormResponses = (state) => state.survey.formResponses;
export const selectFormResponseById = (formId) => (state) =>
  state.survey.formResponses[formId] || EMPTY_FORM_RESPONSE;

// Export reducer
export default surveySlice.reducer;
